export default "__VITE_ASSET__6a1e9088__"